module.exports = "<a href=# class=dock-details>{%-  dockDoorEditName %} </a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/dockConfigurations/html/doorLookup/html/dockDetails.html
// module id = 1278
// module chunks = 1